export const headCells = [
    { id: 'name', numeric: false, disablePadding: false, label: 'Candidate', minWidth: 250, sortable: true },
    { id: 'phone', numeric: false, disablePadding: false, label: 'Phone Number', minWidth: 180, sortable: false },
    { id: 'similarity_score', numeric: true, disablePadding: false, label: 'Similarity', minWidth: 130, sortable: true },
    { id: 'skill_score', numeric: true, disablePadding: false, label: 'Skill', minWidth: 110, sortable: true },
    { id: 'final_score', numeric: true, disablePadding: false, label: 'Final Score', minWidth: 130, sortable: true },
];

export const rowsPerPageOptionsConfig = [10, 25, 50, 100];
